function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "#clip0"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M38.9995 78.6582C60.5386 78.6582 77.9995 61.1973 77.9995 39.6582C77.9995 18.1191 60.5386 0.658203 38.9995 0.658203C17.4604 0.658203 -0.000488281 18.1191 -0.000488281 39.6582C-0.000488281 61.1973 17.4604 78.6582 38.9995 78.6582Z",
  fill: "#FF2828"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.7955 27.961C31.6435 27.8492 31.442 27.832 31.2735 27.918C31.1055 28.0041 30.9995 28.1786 30.9995 28.3693V50.6304C30.9995 50.8212 31.1055 50.9957 31.2735 51.0817C31.3445 51.1182 31.4225 51.1364 31.4995 51.1364C31.604 51.1364 31.708 51.1035 31.7955 51.0387L46.7955 39.9082C46.924 39.8126 46.9995 39.6608 46.9995 39.4999C46.9995 39.339 46.924 39.1872 46.7955 39.0916L31.7955 27.961Z",
  fill: "white"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  x: -0.000488281,
  width: 78.0001,
  height: 79,
  rx: 8,
  fill: "white"
})));

function SvgPlay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 79,
    viewBox: "0 0 78 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.aedec1dd.svg";
export { ForwardRef as ReactComponent };